var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Send",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "warning_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M101.733,266.168a.722.722,0,0,1-.386-.1.741.741,0,0,1-.266-.277.806.806,0,0,1-.109-.369.689.689,0,0,1,.107-.394l7.228-12.485a.757.757,0,0,1,.293-.288.784.784,0,0,1,.742,0,.757.757,0,0,1,.293.288l7.228,12.485a.689.689,0,0,1,.107.394.806.806,0,0,1-.109.369.741.741,0,0,1-.266.277.722.722,0,0,1-.386.1Zm.865-1.266h12.748l-6.374-10.975Zm6.374-1.007a.67.67,0,1,0-.486-.2A.66.66,0,0,0,108.973,263.895Zm0-2.208a.622.622,0,0,0,.633-.633V258.1a.633.633,0,1,0-1.266,0v2.955a.622.622,0,0,0,.633.633ZM108.973,259.413Z",
    transform: "translate(-96.973 -247.156)",
    fill: "#fe5f55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.5f87f9cc14b6361be972452a73b522bc.svg";
export { ForwardRef as ReactComponent };